import type { ProjectMetricViewProps } from "@phoenix/pages/project/metrics/types";

import { SpanAttributePercentilesTimeSeries } from "./SpanAttributePercentilesTimeSeries";

/**
 * Percentile charts for the voice pipeline's latency SLOs.
 *
 * Each is the same percentile chart pointed at a different span attribute. All
 * five are published in seconds by the agent's Phoenix exporter, so they share
 * one axis unit and can be read side by side.
 *
 * Every chart passes a `filterCondition` narrowing to the span that carries the
 * attribute; the resolver requires one. For these five the attribute is sparse
 * enough that the filter is mostly a semantic guard rather than a speed-up, but
 * it bounds the cost for any future metric whose attribute is widespread.
 */

export function LLMTimeToFirstTokenTimeSeries(props: ProjectMetricViewProps) {
  return (
    <SpanAttributePercentilesTimeSeries
      {...props}
      attributePath={["llm", "ttft"]}
      filterCondition="name == 'llm_node'"
    />
  );
}

export function TTSTimeToFirstByteTimeSeries(props: ProjectMetricViewProps) {
  return (
    <SpanAttributePercentilesTimeSeries
      {...props}
      attributePath={["tts", "ttfb"]}
      filterCondition="name == 'tts_node'"
    />
  );
}

export function STTTranscriptionDelayTimeSeries(props: ProjectMetricViewProps) {
  return (
    <SpanAttributePercentilesTimeSeries
      {...props}
      attributePath={["stt", "transcription_delay"]}
      filterCondition="name == 'user_turn'"
    />
  );
}

export function STTEndOfTurnDelayTimeSeries(props: ProjectMetricViewProps) {
  return (
    <SpanAttributePercentilesTimeSeries
      {...props}
      attributePath={["stt", "end_of_turn_delay"]}
      filterCondition="name == 'user_turn'"
    />
  );
}

export function AgentTurnE2ELatencyTimeSeries(props: ProjectMetricViewProps) {
  return (
    <SpanAttributePercentilesTimeSeries
      {...props}
      // `lk.e2e_latency` keeps its native livekit name: `agent_turn` is not one
      // of the spans the exporter rewrites, so the attribute passes through
      // untouched rather than being renamed into an `oi.*`-style namespace.
      attributePath={["lk", "e2e_latency"]}
      filterCondition="name == 'agent_turn'"
    />
  );
}
